import axios from 'axios'
import { host } from '../../../helper/config'
import { ITEM_PER_PAGE } from '../../../helper/helper'

const PLUGINS_NAME = 'admin-loto-result'

export const getList = async (token, query, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-list`, {
        ...query,
        page: page,
        itemPerPage: ITEM_PER_PAGE
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const calculateReward = async (token, periodId) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/calculate-reward`, {
        periodId: periodId
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const getCalculateRewardProgress = async (token, periodId) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/calculate-reward-progress`, {
        periodId: periodId
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const getLotoRuleSet = async (token) => {
    try {
        const response = await axios.get(`${host}/${PLUGINS_NAME}/get-rule-set`, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': token
            },
        })

        if (response && response.status === 200) {
            return response.data || {}
        }
    } catch (error) {
        return null
    }
    return null
}

export const setLotoRuleSet = async (token, ruleSet) => {
    try {
        const response = await axios.post(`${host}/${PLUGINS_NAME}/set-rule-set`, {
            ruleSet
        }, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': token
            },
        })

        if (response && response.status === 200) {
            return response.data || {}
        }
    } catch (error) {
        return null
    }
    return null
}

export const getSolvedCart = async (token) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-list-channel-solved-cart`, {

    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}
